import { render } from "./NovaRequisicaoMateriaisNew.vue?vue&type=template&id=e0c9afd4&scoped=true"
import script from "./NovaRequisicaoMateriaisNew.vue?vue&type=script&lang=js"
export * from "./NovaRequisicaoMateriaisNew.vue?vue&type=script&lang=js"

import "./NovaRequisicaoMateriaisNew.vue?vue&type=style&index=0&id=e0c9afd4&scoped=true&lang=css"
import "./NovaRequisicaoMateriaisNew.vue?vue&type=style&index=1&id=e0c9afd4&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e0c9afd4"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QSelect,QItem,QItemSection,QIcon,QField});
